import { Spinner } from '@frontend/components/common';
import React from 'react';
import { BarcodeFormat } from 'scanbot-web-sdk/@types';

import OnboardScanner from '../onboard-scanner/onboard-scanner.component';
import ScanbotScanner from '../scanbot/scanbot-scanner/scanbot-scanner.component';
import useMobileDynamicOnboardScanner from './mobile-dynamic-onboard-scanner.controller';

const ID = 'mobile-dynamic-onboard-scanner';
export const ONBOARD_SCANNER_KEY = 'tlp-onb-scnr';
export interface MobileDynamicOnboardScannerProps {
    callback?: (value: string) => void | Promise<void>;
    formats?: BarcodeFormat[];
    disabled?: boolean;
}

export const MobileDynamicOnboardScanner = (props: MobileDynamicOnboardScannerProps) => {
    const viewProps = useMobileDynamicOnboardScanner(props);
    if (viewProps.loading) {
        return (
            <div className='bg-always-black flex h-full w-full items-center justify-center'>
                <Spinner className='text-border-default fill-always-white size-8' />
            </div>
        );
    }

    if (viewProps.onboardScanner === true) {
        return (
            <OnboardScanner
                callback={props.callback}
                disabled={props.disabled}
            />
        );
    }
    return (
        <ScanbotScanner
            formats={props.formats}
            callback={props.callback}
        />
    );
};

export default MobileDynamicOnboardScanner;
